import { Box, Skeleton, Stack } from "@mui/material";
// config
import colors from "../../../config/colors";

const SimilarCreatorsTabSkeleton = () => {
  const skeletonCards = Array.from({ length: 8 }, (_, index) => index);

  return (
    <Box
      sx={{
        height: "100vh",
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(210px, 1fr))",
        gap: 1,
        pr: 0.5,
        overflow: "auto",
        "&::-webkit-scrollbar": {
          width: "4px",
        },
        "&::-webkit-scrollbar-track": {
          backgroundColor: colors.gray100,
        },
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: colors.primary500,
          borderRadius: "2px",
        },
        "&::-webkit-scrollbar-thumb:hover": {
          backgroundColor: colors.primary500,
          opacity: 0.8,
        },
      }}
    >
      {skeletonCards.map((index) => (
        <Box
          key={index}
          sx={{
            border: `1px solid ${colors.gray100}`,
            borderRadius: "4px",
            p: "12px",
            gap: "12px",
            flexDirection: "column",
            display: "flex",
            backgroundColor: colors.white,
          }}
        >
          {/* Profile section */}
          <Box display="flex" alignItems="center" gap={2}>
            <Skeleton variant="circular" width={40} height={40} />
            <Box flex={1}>
              <Skeleton variant="text" width="80%" height={20} />
              <Skeleton variant="text" width="60%" height={16} />
            </Box>
          </Box>

          {/* Followers section */}
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Skeleton variant="text" width={60} height={16} />
            <Skeleton variant="text" width={50} height={16} />
          </Stack>

          {/* Recent Posts section */}
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Skeleton variant="text" width={70} height={16} />
            <Skeleton variant="text" width={40} height={16} />
          </Stack>

          {/* Median Views section */}
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Skeleton variant="text" width={80} height={16} />
            <Skeleton variant="text" width={50} height={16} />
          </Stack>

          {/* Engagement section */}
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Skeleton variant="text" width={70} height={16} />
            <Skeleton variant="text" width={40} height={16} />
          </Stack>

          {/* Conversion section */}
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Skeleton variant="text" width={70} height={16} />
            <Skeleton variant="text" width={40} height={16} />
          </Stack>

          {/* Actions section */}
          <Box display="flex" justifyContent="center" mt={1} gap={2}>
            <Skeleton
              variant="rectangular"
              width={80}
              height={32}
              sx={{ borderRadius: 1 }}
            />
            <Skeleton
              variant="rectangular"
              width={80}
              height={32}
              sx={{ borderRadius: 1 }}
            />
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default SimilarCreatorsTabSkeleton;
